// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"buddieshrAppList_wrapper__qEFQV","title":"buddieshrAppList_title__6_5gw","list":"buddieshrAppList_list__pfVlh","ctaBottom":"buddieshrAppList_ctaBottom__vWgon"};